module.exports = __webpack_public_path__ + "img/ic_qrcode_facebook.e440a40.png";